interface ITUIconProps {
  width: number;
  height: number;
}

function ITUIcon({ width, height }: ITUIconProps) {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width={width}
      height={height}
      viewBox='0 0 330 330'
      enableBackground='new 0 0 330 330'
      xmlSpace='preserve'
    >
      <g>
        <path
          fill='#00A0E2'
          d='M82.952,124.043c0.773-0.001,1.4,0.625,1.401,1.397c0,0.001,0,0.002,0,0.003v84.808
           c0.001,0.774-0.625,1.404-1.401,1.406H57.563c-0.774-0.005-1.4-0.634-1.4-1.406v-84.808c0.001-0.773,0.627-1.4,1.4-1.401
           L82.952,124.043'
        />
        <path
          fill='#00A0E2'
          d='M174.671,124.043c0.772-0.001,1.399,0.625,1.401,1.397c0,0.001,0,0.002,0,0.003v20.882
           c0.001,0.775-0.627,1.405-1.401,1.406h-22.162c-0.775-0.001-1.405,0.626-1.407,1.401v61.118c0.001,0.775-0.626,1.404-1.401,1.406
           h-25.389c-0.775-0.002-1.402-0.631-1.4-1.406v-61.118c-0.001-0.773-0.628-1.4-1.401-1.401H99.859
           c-0.776-0.001-1.405-0.63-1.407-1.406v-20.882c0.002-0.775,0.631-1.402,1.407-1.401L174.671,124.043'
        />
        <path
          fill='#00A0E2'
          d='M273.469,124.043c0.775-0.001,1.405,0.625,1.407,1.401v43.222c0,28.627-15.003,43.762-43.383,43.762
           c-27.415,0-41.314-14.938-41.314-44.404v-42.579c-0.002-0.773,0.625-1.4,1.396-1.401c0.001,0,0.003,0,0.003,0h25.383
           c0.773-0.003,1.404,0.621,1.407,1.394c0,0.002,0,0.004,0,0.007v42.44c0,9.336,2.458,20.463,14.159,20.463
           c9.522,0,14.152-6.692,14.152-20.463v-42.44c0.002-0.775,0.631-1.402,1.404-1.401L273.469,124.043'
        />
        <path
          fill='#00A0E2'
          d='M300.12,299c-16.847-8.309-35.804-17.787-53.286-28.208c2.979-2.308,5.857-4.733,8.635-7.28
           c49.688-44.623,58.594-119.17,20.813-174.242C235.76,28.835,154.519,11.593,92.944,50.359C82.013,35.116,71.035,18.581,59.432,1
           c3.651,7.412,14.479,30.263,27.174,53.608c-35.56,25.314-56.691,66.254-56.726,109.904c-0.027,20.107,4.527,39.955,13.314,58.041
           c32.104,66.994,112.44,95.279,179.436,63.176c5.659-2.713,11.122-5.815,16.349-9.293C259.465,284.91,280.053,291.99,300.12,299
            M151.933,287.311c-30.342-3.065-58.501-17.172-79.129-39.634c-3.183-4.762-5.096-10.258-5.558-15.967
           c13.621,12.949,29.231,23.628,46.236,31.63c18.817,9.116,39.03,15.012,59.797,17.442
           C166.304,285.656,159.086,287.913,151.933,287.311 M64.289,220.365c-0.12,1.24-0.195,2.451-0.247,3.65
           c-1.114-1.211-2.211-2.424-3.255-3.65H56.79c2.234,2.744,4.657,5.447,7.229,8.104c0.096,3.565,0.609,7.106,1.527,10.554
           c-31.833-41.644-33.695-98.909-4.634-142.531c-1.526,6.153-2.171,12.492-1.917,18.826h3.003c-0.479-9.293,1.209-18.571,4.932-27.1
           c4.932-6.21,10.443-11.938,16.461-17.104c3.135-1.763,6.352-3.405,9.651-4.926c7.338,12.878,14.979,25.13,22.007,34.185
           c-7.905,0.468-15.834,0.303-23.712-0.494l1.286,0.362c-0.408-0.035-0.81-0.075-1.223-0.115c2.503,5.207,5.242,10.266,8.147,15.192
           h51.174c-2.676-2.188-5.309-4.456-7.9-6.804c11.356-9.275,23.632-17.363,36.636-24.137c4.354,4.808,9.55,8.78,15.33,11.724
           c7.32,3.886,15.414,6.094,23.695,6.465c0.898,4.14,1.676,8.4,2.317,12.751h3.056c-0.631-4.357-1.396-8.616-2.291-12.774
           c7.646-0.322,14.164-2.773,18.074-7.251c6.315,6.102,12.02,12.809,17.021,20.026h3.646c-5.472-8.158-11.806-15.703-18.89-22.506
           c2.174-3.953,2.666-8.615,1.365-12.936c-0.908-3.214-2.369-6.245-4.317-8.957c5.538,0.932,10.715,3.363,14.969,7.027
           c34.25,34.428,44.987,85.809,27.394,131.072c-10.522,21.894-35.987,33.782-67.284,34.655c13.219-3.342,23.747-7.924,36.229-15.83
           c-4.668-2.142-9.354-4.483-14.039-6.985c-1.444,0.074-2.908,0.119-4.42,0.119c-26.07,0-42.31-11.481-47.591-34.185
           c-8.188-6.274-16.187-12.813-23.918-19.479v18.998c10.955,9.979,21.893,19.143,32.106,27.588
           c-7.859,5.235-33.306,12.965-38.29,13.836c4.283,3.429,8.618,6.688,13.005,9.785c-10.798-3.026-21.313-6.988-31.423-11.84
           c-1.005-0.481-2.004-0.974-2.997-1.472c-0.144-0.067-0.281-0.137-0.419-0.206c-1.86-0.938-3.696-1.896-5.506-2.876
           c-12.22-6.553-23.421-14.851-33.249-24.632v4.214c2.957,2.865,6.094,5.629,9.41,8.291c10.376,8.183,21.719,15.06,33.771,20.476
           c12.053,5.611,24.651,9.971,37.598,13.004c6.985,4.649,14.063,8.965,21.226,12.94c-0.08,0.146-0.166,0.293-0.253,0.44
           c-5.528,9.377-11.541,16.783-17.793,22.061c-19.779-1.722-41.338-7.504-62.266-17.511c-18.826-9.004-35.195-20.584-47.729-33.308
           c-0.021-2.252,0.086-4.502,0.321-6.74h-3.023v0.004H64.289z M172.4,71.93c1.035,3.649,2.765,7.065,5.094,10.059
           c-13.106,6.887-25.481,15.084-36.936,24.464c-13.625-12.648-26.25-27.427-38.726-43.985c0.068-0.023,0.132-0.057,0.201-0.081
           c0.012-0.005,0.029-0.011,0.04-0.017v0.006c5.71-2.136,11.589-3.792,17.575-4.949c17.94-3.381,36.4-2.845,54.115,1.573
           C171.586,62.952,171.097,67.613,172.4,71.93 M175.318,71.155c-1.166-3.754-0.661-7.827,1.383-11.187
           c0.04-0.063,0.092-0.121,0.133-0.184c9.804,2.631,19.299,6.296,28.328,10.932c-1.912,0.551-3.855,1.164-5.828,1.837
           c-6.522,2.257-12.891,4.94-19.063,8.032C178.006,77.807,176.32,74.6,175.318,71.155 M206.373,67.957
           c-8.736-4.47-17.896-8.055-27.348-10.702c3.721-3.37,9.479-5.081,16.146-5.093C199.624,56.879,203.395,62.195,206.373,67.957
            M199.604,52.397c6.785,0.771,13.364,2.805,19.4,5.994c4.409,2.276,8.473,5.166,12.069,8.584
           c-6.933-0.128-13.853,0.661-20.578,2.348C207.6,63.241,203.939,57.553,199.604,52.397 M200.311,75.415
           c2.904-0.993,5.735-1.837,8.508-2.555c1.226,2.635,2.385,5.416,3.48,8.342c2.219,6.004,4.055,12.143,5.5,18.378
           c-7.561-0.504-14.927-2.604-21.617-6.161c-5.198-2.664-9.898-6.202-13.898-10.461C188.126,80.066,194.146,77.547,200.311,75.415
            M215.129,80.146c-0.648-1.734-1.32-3.418-2.016-5.053c8.732,5.16,16.89,11.236,24.332,18.126
           c-3.45,4.076-9.435,6.229-16.529,6.407C219.408,93.016,217.475,86.509,215.129,80.146 M213.412,71.781
           c6.803-1.534,13.798-2.035,20.75-1.487c2.625,3,4.57,6.534,5.701,10.357c1.001,3.314,0.744,6.881-0.719,10.019
           C231.283,83.453,222.654,77.119,213.412,71.781 M220.395,55.71c-7.326-3.893-15.43-6.1-23.719-6.459
           c-2.145-2.146-4.507-4.061-7.051-5.713c19.788,3.984,38.309,12.728,53.959,25.475c-2.596-0.818-5.262-1.385-7.964-1.694
           C231.288,62.562,226.129,58.628,220.395,55.71 M192.203,49.355c-6.953,0.545-12.861,2.899-16.535,7.01
           c-18.498-4.787-37.823-5.436-56.6-1.9c-6.331,1.224-12.544,2.987-18.574,5.271v0.012c-0.178,0.069-0.361,0.144-0.545,0.212
           c-0.138-0.19-0.287-0.385-0.425-0.574c19.631-12.016,42.207-18.355,65.224-18.316c3.704,0,7.365,0.159,10.988,0.477
           C181.484,42.224,187.041,44.899,192.203,49.355 M177.729,281.201c3.854,0.305,7.666,0.477,11.42,0.477
           c2.785,0,5.546-0.086,8.263-0.258c3.695-0.23,7.258-0.632,10.68-1.172c-13.332,4.91-27.4,7.508-41.607,7.684
           C170.535,286.242,174.324,283.975,177.729,281.201 M181.174,278.229c6.369-6.135,11.828-13.147,16.208-20.83
           c0.104-0.174,0.201-0.346,0.3-0.518c9.709,5.311,19.543,10.088,29.424,14.475c-0.684,0.396-1.377,0.771-2.064,1.147
           C212.77,277.252,197.669,279.191,181.174,278.229 M212.518,246.713c4.195-0.087,8.336-0.361,12.377-0.839
           c20.756-2.463,37.453-9.888,48.607-21.364c-8.975,15.955-21.359,29.731-36.273,40.346
           C228.568,259.404,220.311,253.342,212.518,246.713'
        />
      </g>
    </svg>
  );
}

export default ITUIcon;
